/*
 * お気に入り（2026-09-26）。一覧は固定ページ「お気に入り」（/pages/favorites）
 * ------------------------------------------------------------------
 * ・保存先はお客様のブラウザ（localStorage）。ログイン不要・サーバーには送らない。
 *   別の端末とは共有されない。ブラウザのデータを消すと消える。
 * ・保存するのは商品のハンドル（URLの末尾）と追加した時刻だけ。個人情報は持たない。
 * ・画面側の約束
 *     [data-fav-handle="ハンドル"]  … ハートのボタン（押すと追加／解除）
 *     [data-fav-count]              … 件数を入れる（0件なら data-fav-zero 属性が付く）
 *     [data-fav-list]               … 一覧を描く場所（開くたびに価格・在庫を読み直す）
 * ・上限 50点。新しく追加した順。
 */
(function () {
  'use strict';

  var KEY = 'words_fav_v1';
  var MAX = 50;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var favPage = root + 'pages/favorites';

  /* ---------- 保存と読み出し（使えない環境でも落ちないようにする） ---------- */
  function load() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var a = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(a)) return [];
      return a.filter(function (x) { return x && typeof x.h === 'string' && x.h !== ''; });
    } catch (e) { return []; }
  }
  function save(a) {
    try { window.localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX))); return true; }
    catch (e) { return false; }
  }
  function has(h) {
    var a = load();
    for (var i = 0; i < a.length; i++) { if (a[i].h === h) return true; }
    return false;
  }
  function add(h) {
    var a = load().filter(function (x) { return x.h !== h; });
    a.unshift({ h: h, t: Date.now() });
    return save(a);
  }
  function remove(h) {
    return save(load().filter(function (x) { return x.h !== h; }));
  }

  /* 翻訳（2026-10-02）：layout/theme.liquid が出す window.WORDS_T.fav を使う。無ければ日本語 */
  function FT(k, ja) { var t = window.WORDS_T && window.WORDS_T.fav; return (t && t[k]) || ja; }

  /* ---------- ボタンの表示をそろえる ---------- */
  function paintButtons() {
    var a = load();
    var set = {};
    a.forEach(function (x) { set[x.h] = true; });
    var btns = document.querySelectorAll('[data-fav-handle]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      var on = !!set[b.getAttribute('data-fav-handle')];
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? FT('remove', 'お気に入りから外す') : FT('add', 'お気に入りに追加'));
      var lb = b.querySelector('[data-fav-label]');
      var lt = on ? FT('label_on', 'お気に入り済み') : FT('label', 'お気に入り');
      /* 同じ文字を入れ直すと MutationObserver が反応して無限に回るので、違うときだけ書く */
      if (lb && lb.textContent !== lt) lb.textContent = lt;
    }
    var cs = document.querySelectorAll('[data-fav-count]');
    for (var j = 0; j < cs.length; j++) {
      if (cs[j].textContent !== String(a.length)) cs[j].textContent = String(a.length);
      if (a.length === 0) cs[j].setAttribute('data-fav-zero', '');
      else cs[j].removeAttribute('data-fav-zero');
    }
  }

  /* ---------- 小さなお知らせ ---------- */
  var toastEl = null, toastTimer = null;
  function toast(msg, withLink) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'wf-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var s = document.createElement('span');
    s.textContent = msg;
    toastEl.appendChild(s);
    if (withLink && location.pathname.indexOf('/pages/favorites') === -1) {
      var l = document.createElement('a');
      l.href = favPage;
      l.textContent = FT('view_list', '一覧を見る');
      toastEl.appendChild(l);
    }
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  /* ---------- クリック（後から足されたカードにも効くよう document で受ける） ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-fav-handle]') : null;
    if (b) {
      e.preventDefault();
      e.stopPropagation();
      var h = b.getAttribute('data-fav-handle');
      var ok;
      if (has(h)) {
        ok = remove(h);
        if (ok) toast(FT('removed', 'お気に入りから外しました'), false);
      } else {
        if (load().length >= MAX) {
          toast(FT('limit', 'お気に入りは%MAX%点までです。古いものから外してください').replace('%MAX%', MAX), false);
          return;
        }
        ok = add(h);
        if (ok) toast(FT('added', 'お気に入りに追加しました'), true);
      }
      if (!ok) toast(FT('save_failed', 'このブラウザでは保存できませんでした（プライベートモードなど）'), false);
      paintButtons();
      renderLists();
      return;
    }
    var r = e.target.closest ? e.target.closest('[data-fav-remove]') : null;
    if (r) {
      e.preventDefault();
      remove(r.getAttribute('data-fav-remove'));
      var li = r.closest('.wf-card');
      if (li && li.parentNode) li.parentNode.removeChild(li);
      paintButtons();
      var list = document.querySelector('[data-fav-list]');
      if (list && load().length === 0) renderLists();
    }
  });

  /* ---------- 一覧 ---------- */
  function yen(cents) {
    var n = Math.round(Number(cents) / 100);
    return '¥' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function imgUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function card(p, h) {
    var li = el('li', 'wf-card');
    var url = root + 'products/' + encodeURIComponent(h);

    var ph = el('a', 'wf-card__ph');
    ph.href = url;
    var src = p.featured_image || (p.images && p.images[0]) || '';
    if (src) {
      var img = document.createElement('img');
      img.src = imgUrl(src, 400);
      img.alt = p.title || '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = 400; img.height = 400;
      ph.appendChild(img);
    }
    if (!p.available) ph.appendChild(el('span', 'wf-card__so', 'SOLD OUT'));
    li.appendChild(ph);

    var tx = el('div', 'wf-card__tx');
    var tags = p.tags || [];
    if (tags.indexOf('cat:xl-size') !== -1) tx.appendChild(el('span', 'wf-card__xl', FT('xl', 'XLサイズ')));
    var nm = el('a', 'wf-card__nm', p.title || '');
    nm.href = url;
    tx.appendChild(nm);
    var pr = el('p', 'wf-card__pr');
    pr.appendChild(el('span', null, yen(p.price)));
    if (p.compare_at_price && p.compare_at_price > p.price) pr.appendChild(el('s', 'wf-card__was', yen(p.compare_at_price)));
    tx.appendChild(pr);
    var rm = el('button', 'wf-card__rm', FT('remove_short', '外す'));
    rm.type = 'button';
    rm.setAttribute('data-fav-remove', h);
    rm.setAttribute('aria-label', FT('remove_item', '%TITLE% をお気に入りから外す').replace('%TITLE%', p.title || ''));
    tx.appendChild(rm);
    li.appendChild(tx);
    return li;
  }

  function renderLists() {
    var boxes = document.querySelectorAll('[data-fav-list]');
    if (!boxes.length) return;
    var items = load();
    for (var i = 0; i < boxes.length; i++) renderOne(boxes[i], items);
  }

  function renderOne(box, items) {
    var ul = box.querySelector('[data-fav-items]');
    var empty = box.querySelector('[data-fav-empty]');
    var note = box.querySelector('[data-fav-missing]');
    if (!ul) return;
    var seq = (Number(box.getAttribute('data-seq')) || 0) + 1;
    box.setAttribute('data-seq', String(seq));

    if (!items.length) {
      ul.innerHTML = '';
      if (empty) empty.hidden = false;
      if (note) note.hidden = true;
      box.removeAttribute('aria-busy');
      return;
    }
    if (empty) empty.hidden = true;
    box.setAttribute('aria-busy', 'true');

    Promise.all(items.map(function (x) {
      return fetch(root + 'products/' + encodeURIComponent(x.h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (res) {
      if (box.getAttribute('data-seq') !== String(seq)) return; /* 途中で描き直しが入ったら捨てる */
      ul.innerHTML = '';
      var missing = 0;
      res.forEach(function (p, k) {
        if (!p) { missing++; return; }
        ul.appendChild(card(p, items[k].h));
      });
      if (note) {
        note.hidden = missing === 0;
        note.textContent = missing ? FT('missing', '販売を終了した・準備中の商品 %COUNT%点は表示していません。').replace('%COUNT%', missing) : '';
      }
      if (empty) empty.hidden = res.length - missing > 0;
      box.removeAttribute('aria-busy');
    });
  }

  /* ---------- 起動 ---------- */
  function boot() {
    paintButtons();
    renderLists();
    /* 一覧の絞り込み・追加読み込みで差し込まれたカードにも色を付ける */
    if ('MutationObserver' in window) {
      var t = null;
      new MutationObserver(function (ms) {
        for (var i = 0; i < ms.length; i++) {
          if (ms[i].addedNodes && ms[i].addedNodes.length) {
            clearTimeout(t);
            t = setTimeout(paintButtons, 60);
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  /* 別タブで変わったとき */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { paintButtons(); renderLists(); }
  });
  /* 戻るボタンでキャッシュから表示されたとき */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { paintButtons(); renderLists(); }
  });

  window.WordsFav = { list: load, has: has, add: add, remove: remove, refresh: function () { paintButtons(); renderLists(); } };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
